import { render, staticRenderFns } from "./BrandingLogo.vue?vue&type=template&id=dc474c5e&scoped=true&"
import script from "./BrandingLogo.vue?vue&type=script&lang=js&"
export * from "./BrandingLogo.vue?vue&type=script&lang=js&"
import style0 from "./BrandingLogo.vue?vue&type=style&index=0&id=dc474c5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc474c5e",
  null
  
)

export default component.exports